import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';

// キャッシュバスティング用
const TIMESTAMP = '20241226';

const Favicon = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    // ダークモードかどうか
    const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    setIsDarkMode(darkModeMediaQuery.matches);

    // ダークモードの変更を監視
    const handleThemeChange = (e: MediaQueryListEvent) => {
      setIsDarkMode(e.matches);
    };

    darkModeMediaQuery.addEventListener('change', handleThemeChange);

    return () => {
      darkModeMediaQuery.removeEventListener('change', handleThemeChange);
    };
  }, []);

  return (
    <Helmet>
      <link rel="icon" href={`${isDarkMode ? '/favicon-dark.ico' : '/favicon.ico'}?${TIMESTAMP}`} />
    </Helmet>
  );
};

export default Favicon;
